import { useContext } from 'react';
import { CollapseDrawerContext } from '../contexts/CollapseDrawerContext';

// ================================|| Collapse Drawer Hooks ||================================ /

const useCollapseDrawer = () => useContext(CollapseDrawerContext);

export default useCollapseDrawer;
